import axios from 'axios'
import store from '../store'
import axiosRetry from 'axios-retry'
import contentDisposition from 'content-disposition'
import { Toast } from 'vant'
import { removeToken, getToken } from '@/utils/auth' // get token from cookie
import { saveBlob } from '@/utils/index'
import { thirdAuthUrl } from '@/api/loginToB.js'
axiosRetry(axios, { retries: 3, retryDelay: (retryCount) => 500 * retryCount, retryCondition: (error) => error.message === 'Network Error' || error.code === 'ECONNABORTED' || false })
const ajax = function(options) {
  const NODE_ENV = process.env.NODE_ENV
  const BASE_API = process.env.VUE_APP_BASE_API
  const token = getToken()
  const defaults = {
    responseType: 'json',
    method: 'post',
    baseURL: BASE_API,
    url: '',
    data: {},
    timeout: 30000,
    withCredentials: true,
    hideToast: false,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': `bearer ${token}`
    },
    transformResponse: [
      function(data) {
        try {
          return JSON.parse(data)
        } catch (error) {
          return data
        }
      }
    ]
  }

  const clone = (target) => {
    if (Object.prototype.toString.call(target) === '[object Object]' || Object.prototype.toString.call(target) === '[object Array]') {
      const result = Array.isArray(target) ? [] : {}
      for (const key in target) {
        result[key] = clone(target[key])
      }
      return result
      // 过滤入参前后空格
    } else if (typeof target === 'string') {
      return target.replace(/(^\s*)|(\s*$)/g, '')
    } else {
      return target
    }
  }

  options = { ...defaults, ...options }
  options.data = options.data ? clone(options.data) : {}

  return new Promise((resole, reject) => {
    let data = {}
    let code = 0
    let message = ''
    axios(options)
      .then((response) => {
        const json = response.data || {}
        data = json.data || {}
        code = json.code
        message = json.msg || '网络异常，请稍后再试或更换网络后重试.'

        // 文件下载
        if (options.responseType === 'blob') {
          const disposition = response.headers['content-disposition']
          let fileName = 'default'
          let cdResult = null
          try {
            cdResult = contentDisposition.parse(disposition)
          } catch (e) {
            console.log(e)
          }
          if (cdResult && cdResult.parameters && cdResult.parameters.filename) {
            fileName = decodeURI(cdResult.parameters.filename)
          }
          const fileType = response.headers['content-type']
          const fileData = new Blob([json], { type: fileType })
          saveBlob(fileData, fileName)
          resole(json)
          return false
        }

        if (json.success) {
          resole(data)

          // 奔驰auth集成的相关编码，需要放行，然后进行相关的业务处理
        } else if (code === 1200 || code === 1201 || code === 1202) {
          resole({ code, message })
        } else if (code === 1101 || code === 1102 || code === 1103 || code === 1104) {
          // 1101 token无效或已过期
          // 1102 已在其他终端登录 强制下线
          // 1103 用户冻结 强制下线
          // 1104 权限变更等原因 强制下线
          removeToken()
          // 获取当前登录人的租户号
          const { type } = store.getters.loginUser
          // 获取当前是否是C端用户
          let isCustomer = type === 'C'
          // 如果缓存中没有值，则判断接口
          if (!type) {
            isCustomer = options.url.indexOf(process.env.VUE_APP_BASIC_DATA_API_C) >= 0
          }
          // 跳转到登录页
          // window.location.href = `${process.env.VUE_APP_ROUTER}/${isCustomer ? 'ciamLogin' : 'authLogin'}`
          const source = localStorage.getItem('source')
          localStorage.removeItem('source')
          console.log('utils.js')
          thirdAuthUrl({ target: source === 'CIAM' || isCustomer ? 'ciam' : 'auth', type: 'LOGIN' }).then(url => { window.location = url })
        } else {
          reject({ code, message })
          // hideToast=true或用户信息失效不展示报错信息
          if (options.hideToast || options.url.indexOf('user/eiam/user/getCurrUserInfo') >= 0) {
            return
          }
          Toast({ duration: 3500, message })
        }
      })
      .catch((error) => {
        if (NODE_ENV !== 'production') {
          console.log(error.message)
        }
        if (error.response) {
          code = error.response.status
          message = error.response.statusText || error.response.data && error.response.data.msg
        } else if (error.request && error.message === 'Network Error') {
          // 网络异常
          message = '连接似乎有问题，请检查网络.'
        } else if (error.request && error.code === 'ECONNABORTED') {
          // 请求超时
          message = '网络异常，请稍后再试.'
        } else if (error.__CANCEL__) {
          // 取消请求
          message = 'cancel request'
          code = '_CANCEL_REQUEST_'
        } else {
          message = 'params setting error'
        }
        reject({ code, message })
        if (options.hideToast) {
          return
        }
        Toast.fail(message)
      })
  })
}
export default ajax



// WEBPACK FOOTER //
// ./src/utils/request.js